import { useEffect, useRef } from 'react'

const useCreatePreview = ({
  backgroundColor,
  textColor,
  linkColor,
  loadScriptContainerId,
  widgetContainerId,
  customTexts,
  language,
}) => {
  const updateTimeOut = useRef()

  useEffect(() => {
    if (!backgroundColor || !textColor) return

    if (updateTimeOut.current) {
      clearTimeout(updateTimeOut.current)
    }

    updateTimeOut.current = setTimeout(() => {
      const script = document.createElement('script')
      script.defer = true
      const configurationObject = {
        text_color: textColor,
        background_color: backgroundColor,
        link_color: linkColor || 'red',
        custom_texts: customTexts?.text,
      }

      const params = new URLSearchParams()

      params.append('configuration', encodeURIComponent(JSON.stringify(configurationObject)))
      params.append('language', language)

      script.src = `${import.meta.env.VITE_REVENI_TOP_BANNER_WIDGET}?${params.toString()}`

      const container = document.getElementById(loadScriptContainerId)
      container.innerHTML = ''

      document.getElementById(widgetContainerId)?.remove()

      const topBannerWidgetContainer = document.createElement('div')
      topBannerWidgetContainer.id = widgetContainerId
      container.parentNode.appendChild(topBannerWidgetContainer)

      container.appendChild(script)
    }, 500)
  }, [textColor, backgroundColor, loadScriptContainerId, widgetContainerId, language, linkColor, customTexts])
}

export default useCreatePreview
